/*
  theme.js — globale JS voor het El Pasha theme.
  Per component komt er later een eigen bestand in assets/ (bijv. cart-drawer.js).
*/

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Echte viewport-hoogte als CSS variabele (--vh) voor mobiel.
     ------------------------------------------------------------------ */

  function setViewportHeight() {
    document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
  }

  setViewportHeight();
  window.addEventListener('resize', setViewportHeight);

  /* ------------------------------------------------------------------
     Mobiel menu.
     ------------------------------------------------------------------ */

  var panel = document.querySelector('[data-menu-panel]');
  var scrim = document.querySelector('[data-menu-scrim]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var closer = document.querySelector('[data-menu-close]');

  if (panel && scrim && toggle) {
    var openMenu = function () {
      panel.hidden = false;
      scrim.hidden = false;

      // Forceer een reflow zodat de transitie vanaf de gesloten stand loopt.
      void panel.offsetWidth;

      panel.classList.add('is-open');
      scrim.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      var firstLink = panel.querySelector('a, button');
      if (firstLink) firstLink.focus();
    };

    var closeMenu = function () {
      panel.classList.remove('is-open');
      scrim.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    };

    toggle.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    scrim.addEventListener('click', closeMenu);
    if (closer) closer.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }
})();

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Veegrails: markeer welke kaart in beeld staat.
     Werkt op elke sectie met een [data-rail] en een [data-rail-dots].
     ------------------------------------------------------------------ */

  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var section = rail.closest('section') || document;
    var dotsHolder = section.querySelector('[data-rail-dots]');
    if (!dotsHolder) return;

    var dots = Array.prototype.slice.call(dotsHolder.children);
    if (dots.length < 2) return;

    var cards = Array.prototype.filter.call(rail.children, function (child) {
      return child.tagName !== 'SPAN';
    });

    var update = function () {
      // De kaart waarvan de linkerrand het dichtst bij de railrand ligt.
      var railLeft = rail.getBoundingClientRect().left;
      var closest = 0;
      var smallest = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.getBoundingClientRect().left - railLeft);
        if (distance < smallest) {
          smallest = distance;
          closest = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closest);
      });
    };

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    });

    update();
  });
})();

/* --------------------------------------------------------------------------
   Veelgestelde vragen — inklappen op mobiel

   De vragen staan open in de HTML. Wie geen JavaScript heeft, en elke crawler,
   ziet dus alle antwoorden; dat is precies wat het FAQ-schema eist, want dat
   moet woordelijk op de pagina staan. Onder 768px klapt dit ze dicht, zoals
   het mobiele ontwerp voorschrijft. De tekst blijft in de DOM.

   Zodra de bezoeker zelf een vraag open- of dichtklapt, laat dit script zijn
   keuze met rust.
   -------------------------------------------------------------------------- */
(function () {
  var lijsten = document.querySelectorAll('[data-collapsible-mobile="ja"]');
  if (!lijsten.length) return;

  var smal = window.matchMedia('(max-width: 767px)');
  var aangeraakt = false;
  var bezig = false;

  var synchroniseer = function () {
    if (aangeraakt) return;

    bezig = true;
    lijsten.forEach(function (lijst) {
      lijst.querySelectorAll('[data-faq-item], [data-collapse-item]').forEach(function (item) {
        item.open = !smal.matches;
      });
    });
    window.requestAnimationFrame(function () {
      bezig = false;
    });
  };

  lijsten.forEach(function (lijst) {
    lijst.addEventListener('toggle', function (event) {
      if (bezig) return;
      if (event.target.hasAttribute && (event.target.hasAttribute('data-faq-item')
        || event.target.hasAttribute('data-collapse-item'))) {
        aangeraakt = true;
      }
    }, true);
  });

  if (smal.addEventListener) {
    smal.addEventListener('change', function () {
      aangeraakt = false;
      synchroniseer();
    });
  }

  synchroniseer();
})();

/* --------------------------------------------------------------------------
   Sorteren op een collectiepagina

   Het formulier werkt zonder JavaScript: kiezen en op de knop drukken. Is er
   wel JavaScript, dan sorteert de keuzelijst meteen en verdwijnt de knop,
   zoals in het ontwerp.
   -------------------------------------------------------------------------- */
(function () {
  var forms = document.querySelectorAll('[data-sort-form]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var knop = form.querySelector('[data-sort-go]');
    var lijst = form.querySelector('select[name="sort_by"]');
    if (!lijst) return;

    if (knop) knop.hidden = true;

    lijst.addEventListener('change', function () {
      form.submit();
    });
  });
})();

/* --------------------------------------------------------------------------
   Springen naar een ingeklapt onderdeel

   Op mobiel staan de artikelen van een juridisch document dicht. Klikt iemand
   in de inhoudsopgave, dan hoort dat artikel open te gaan — anders springt de
   pagina naar een dichte regel en lijkt er niets te gebeuren.
   -------------------------------------------------------------------------- */
(function () {
  var openDoel = function () {
    if (!window.location.hash) return;

    var doel;
    try {
      doel = document.querySelector(window.location.hash);
    } catch (e) {
      return; // Een hash die geen geldige selector is.
    }

    if (doel && doel.tagName === 'DETAILS') doel.open = true;
  };

  window.addEventListener('hashchange', openDoel);
  openDoel();
})();
